import { Service, Inject } from 'vue-di-container';
import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import FileSaver from 'file-saver';

@Service()
export default class ProvidersFinanceService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;


    public async GetBoxes(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/employee-statistics/get-boxes';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetPieChart(intervalOption: number, requestType: number, requestStatus: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/employee-statistics/get-pie-chart';
            const result = await this.axiosService.axiosInstance.post(url, {
                intervalOption: intervalOption,
                requestType: requestType,
                requestStatus: requestStatus
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetBarChart(intervalOption: number, requestType: number, requestStatus: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/employee-statistics/get-bar-chart';
            const result = await this.axiosService.axiosInstance.post(url, {
                intervalOption: intervalOption,
                requestType: requestType,
                requestStatus: requestStatus
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async getAllEmployees(): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/employee-statistics/get-all-employees';
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async Get(model: any): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/employee-statistics';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: model,
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async ExportEmployeeStatistics(
        model: any): Promise<any> {
        const url = window.$config.HostName + 'api/employee-statistics/export-employee-statistics';
        const result = await this.axiosService.axiosInstance.get(url, {
            params: model,
        });
        if (result.data.isSuccess) {
            const array = Buffer.from(result.data.result, 'base64');
            const blob = new Blob([array], { type: 'application/vnd.ms-excel' });
            FileSaver.saveAs(blob, 'EmployeeStatisticsReport.xlsx');
            return result.data;
        } else {
            return result.data;
        }
    }
}